import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {RootStore} from "../../../configureStore";
import {getPageType} from "../../../containers/RegistrationLoginPage/utils";

import {
    //CrossIcon,
    RegToastMessage,
    RegToastMessageGradient,
    TriangleTip,
} from "./Styled";

export const RegistrationToastMessage: React.FC = function () {
    const [showToast, setShowToast] = useState(true);
    const userType = useSelector(
        (state: RootStore) => state.layout.userAndShortlistData?.userBasicDetail?.type,
    );
    const isSignUp = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.googleSignupData?.isSignUp,
    );
    const location = useLocation();
    const {pageStatus} = getPageType(location.pathname);
    const {isUserEditProfile} = pageStatus;
    const isMounted = useRef(false);

    useEffect(() => {
        if (!isMounted.current) {
            const timer = setTimeout(() => {
                setShowToast(false);
            }, 60000);
            return () => {
                clearTimeout(timer);
            };
        }
        isMounted.current = true;
    }, [showToast]);

    if (
        showToast &&
        !isUserEditProfile &&
        (userType === "m1_sa" ||
            userType === "m1a_sa" ||
            userType === "m1_sd" ||
            userType === "m1a_sd" ||
            userType === "t1_sa" ||
            userType === "t1a_sa" ||
            userType === "t1_sd" ||
            userType === "t1a_sd")
    ) {
        let removeGradient, toastMessage;
        if (userType === "m1a_sa" || userType === "m1_sa") {
            removeGradient = true;
            toastMessage = `Mobile signup`;
        } else {
            toastMessage = `Google signup`;
            removeGradient = false;
        }
        return (
            <RegToastMessageGradient removeGradient={removeGradient}>
                <RegToastMessage>
                    <TriangleTip />
                    <p>
                        <span>
                            {isSignUp
                                ? `${toastMessage} successful, please complete your profile to proceed further`
                                : `Please complete your profile to proceed further`}
                        </span>
                    </p>
                    {/* <CrossIcon onClick={() => setShowToast(false)}>
                        &times;
                    </CrossIcon> */}
                </RegToastMessage>
            </RegToastMessageGradient>
        );
    }
    return null;
};
